<template>
	<div class="auth-wrapper auth-v1 fadeInDown primary stripped-bg">
		<div class="auth-inner">
			<v-card class="auth-card">
				<!-- logo -->
				<v-card-title class="d-flex align-center justify-center py-7">
					<router-link to="https://sasapay.co.ke/" class="d-flex align-center">
						<v-img
							:src="require('@/assets/sp/logoo.jpg')"
							max-height="100px"
							max-width="100px"
							alt="logo"
							contain
							class="me-3"
						></v-img>
					</router-link>
				</v-card-title>

				<!-- title -->
				<v-card-text>
					<p class="text-2xl font-weight-semibold text--primary mb-2">
						Reset Password Adventure starts here 🚀
					</p>
					<p class="mb-2" v-if="OTPVerified">
						Please enter your new password and start the adventure.
					</p>
					<p v-if="!OTPVerified" class="mb-2">
						Please enter your registered mobile number and start the adventure.
					</p>
				</v-card-text>

				<!-- login form -->
				<v-card-text>
					<v-form
						v-model="isValid"
						ref="passwordResetForm"
						@submit.prevent="
							OTPVerified ? setNewPassword() : sendResetPasswordLink()
						"
					>
						<v-row>
							<v-col cols="12">
								<v-select
									v-model="formData.country_code"
									:items="countryCodes"
									item-text="name"
									item-value="code"
									outlined
									label="Country"
									class="mb-n5"
									:rules="[rules.country_code.required]"
								>
									<template v-slot:selection="data">
										<v-avatar class="mr-2" size="20">
											<img :src="data.item.flag" alt="" />
										</v-avatar>
										<span>{{ data.item.name }}</span>
									</template>
									<template v-slot:item="data">
										<v-avatar class="mr-2" size="20">
											<img :src="data.item.flag" alt="" />
										</v-avatar>
										<span>{{ data.item.name }}</span>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" v-if="!OTPVerified">
								<v-text-field
									v-model="formData.mobile_number"
									outlined
									dense
									label="Phone Number"
									:rules="[rules.mobile_number.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="12" v-if="OTPVerified">
								<v-text-field
									v-model="formData.new_password"
									outlined
									dense
									@copy.prevent
									@paste.prevent
									:type="isPasswordVisible ? 'text' : 'password'"
									label="Password"
									:rules="rules.password"
									:append-icon="
										isPasswordVisible
											? icons.mdiEyeOffOutline
											: icons.mdiEyeOutline
									"
									@click:append="isPasswordVisible = !isPasswordVisible"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="12" class="mt-n5" v-if="OTPVerified">
								<v-text-field
									v-model="formData.confirm_password"
									outlined
									dense
									@copy.prevent
									@paste.prevent
									:type="isPasswordVisible ? 'text' : 'password'"
									label="Confirm Password"
									:rules="rules.password"
									:append-icon="
										isPasswordVisible
											? icons.mdiEyeOffOutline
											: icons.mdiEyeOutline
									"
									@click:append="isPasswordVisible = !isPasswordVisible"
								></v-text-field>
							</v-col>
						</v-row>
						<v-btn v-if="!submitting" block class="primary" type="submit">
							{{ OTPVerified ? 'Confirm Password' : 'Send Verification Code' }}
						</v-btn>
						<v-btn
							v-if="submitting"
							block
							color="error"
							type="submit"
							rounded
							class="account-btn"
						>
							<i class="fa fa-refresh fa-spin loading-button-spinner"></i
							>Processing...please wait
						</v-btn>
					</v-form>
				</v-card-text>

				<!-- create new account  -->
				<v-card-text class="d-flex align-center justify-center flex-wrap">
					<span class="me-2"> Already have an account? </span>
					<router-link :to="{ name: 'Login' }"> Sign in instead </router-link>
				</v-card-text>
			</v-card>
		</div>

		<!-- background triangle shape  -->
		<img
			class="auth-mask-bg"
			height="173"
			:src="
				require(`@/assets/images/misc/mask-${
					$vuetify.theme.dark ? 'dark' : 'dark'
				}.png`)
			"
			alt=""
		/>

		<!-- tree -->
		<v-img
			class="auth-tree"
			width="247"
			height="185"
			src="@/assets/sp/code.png"
		></v-img>

		<!-- tree  -->
		<v-img
			class="auth-tree-3"
			width="247"
			height="185"
			src="@/assets/sp/freelancer.png"
		></v-img>
	</div>
</template>

<script>
import {
	mdiFacebook,
	mdiTwitter,
	mdiGithub,
	mdiGoogle,
	mdiEyeOutline,
	mdiEyeOffOutline,
} from '@mdi/js';
import { mapActions } from 'vuex';
import { EventBus } from '../../../../shared/utilities/event-bus';

export default {
	data() {
		const socialLink = [
			{
				icon: mdiFacebook,
				color: '#4267b2',
				colorInDark: '#4267b2',
			},
			{
				icon: mdiTwitter,
				color: '#1da1f2',
				colorInDark: '#1da1f2',
			},
			{
				icon: mdiGithub,
				color: '#272727',
				colorInDark: '#fff',
			},
			{
				icon: mdiGoogle,
				color: '#db4437',
				colorInDark: '#db4437',
			},
		];

		return {
			isValid: false,
			OTPVerified: false,
			isPasswordVisible: false,
			//
			formData: {
				new_password: '',
				country_code: '',
				mobile_number: '',
				confirm_password: '',
			},
			socialLink,
			submitting: false,

			icons: {
				mdiEyeOutline,
				mdiEyeOffOutline,
			},
			rules: {
				country_code: {
					required: (value) => !!value || 'Country is required',
				},
				mobile_number: {
					required: (value) => !!value || 'Mobile number is Required.',
				},
				password: [
					(value) => !!value || 'Password is required',
					(value) =>
						!this.isCapsLockOn ||
						value.toLowerCase() !== value ||
						'Caps lock is on',
				],
			},
			countryCodes: [
				{
					name: 'Kenya',
					code: '254',
					flag: require('@/assets/images/KE.png'),
				},
				{
					name: 'Tanzania',
					code: '255',
					flag: require('@/assets/images/TZ.png'),
				},
				{
					name: 'Uganda',
					code: '256',
					flag: require('@/assets/images/UG.png'),
				},
				{
					name: 'Somalia',
					code: '252',
					flag: require('@/assets/images/SO.png'),
				},
				{
					name: 'United States',
					code: '1',
					flag: require('@/assets/images/US.png'),
				},
			],
		};
	},
	mounted() {
		//submitting
		EventBus.$on('submitting', (val) => {
			this.submitting = val;
		});
		EventBus.$on('OTPVerified', (val) => {
			this.OTPVerified = val;
		});
		//if OTP has been sent
		EventBus.$on('hasSentCode', () => {
			this.$otpInput.openOTP({
				title: 'Verify Your Identity',
				text: `An OTP has been sent to your phone ending ******${this.formData.mobile_number.substr(
					-4
				)}`,
				length: 6,
				input: true,
				onConfirm: (input) => {
					this.$store.dispatch('Auth/verifyOTP', {
						otp: input,
						...this.formData,
					});
				},
			});
		});
	},
	methods: {
		...mapActions({
			/**
			 * Send OTP
			 * @param dispatch
			 */
			sendResetPasswordLink: function (dispatch) {
				this.submitting = true;
				if (!this.isValid) {
					this.$refs.passwordResetForm.validate();
					this.submitting = false;
				} else {
					dispatch('Auth/sendResetPasswordLink', { ...this.formData });
				}
			},
			/**
			 * Set New Password
			 * @param dispatch
			 */
			setNewPassword: function (dispatch) {
				this.submitting = true;
				if (!this.isValid) {
					this.$refs.passwordResetForm.validate();
					this.submitting = false;
				} else {
					dispatch('Auth/setPassword', { ...this.formData });
				}
			},
		}),
	},
};
</script>
<style scoped>
@import url('../styles/auth.css');
.stripped-bg {
	background: url('~@/assets/sp/home-bg.png');
}
</style>
<style lang="scss">
@import '~@/plugins/default-preset/preset/pages/auth.scss';
</style>
